/* Generated by TinySVG. Do not edit directly. */
export const iconNames = [
  "3d-rotate",
  "3d-view",
  "a-large-small",
  "activity",
  "alarm-clock",
  "alert-circle",
  "alert-triangle",
  "align-center",
  "align-left",
  "align-right",
  "apartment",
  "apartment-filled",
  "apartment-juicy",
  "archive",
  "archive-restore",
  "arrow-down",
  "arrow-down-left",
  "arrow-down-right",
  "arrow-down-wide-narrow",
  "arrow-left",
  "arrow-left-to-line",
  "arrow-right",
  "arrow-right-left",
  "arrow-up",
  "arrow-up-down",
  "arrow-up-left",
  "arrow-up-right",
  "arrow-up-wide-narrow",
  "at-sign",
  "award",
  "badge-check",
  "bar-chart",
  "bar-chart-filled",
  "bar-chart-increasing",
  "bell",
  "bike",
  "bold",
  "book-open",
  "bookmark",
  "bot",
  "bot-filled",
  "box",
  "box-filled",
  "boxes",
  "braces",
  "brain",
  "brain-filled",
  "briefcase",
  "bug",
  "calculator",
  "calendar",
  "calendar-check",
  "calendar-clock",
  "camera",
  "caret-down",
  "caret-left",
  "caret-right",
  "caret-up",
  "check",
  "check-check",
  "check-circle",
  "chevron-down",
  "chevron-down-small",
  "chevron-left",
  "chevron-left-small",
  "chevron-right",
  "chevron-right-small",
  "chevron-up",
  "chevron-up-small",
  "chevrons-down",
  "chevrons-down-up",
  "chevrons-left",
  "chevrons-right",
  "chevrons-up",
  "chevrons-up-down",
  "circle",
  "circle-arrow-down",
  "circle-chevron-down",
  "circle-circle",
  "circle-circle-juicy",
  "circle-dashed",
  "circle-dot",
  "circle-paused",
  "circle-plus",
  "circle-slash",
  "circle-user",
  "circle-user-filled",
  "circle-user-juicy",
  "clipboard",
  "clipboard-check",
  "clipboard-check-filled",
  "clock",
  "code",
  "code-xml",
  "coffee",
  "column-3",
  "columns",
  "component",
  "component-filled",
  "contact",
  "contact-filled",
  "contact-juicy",
  "copy",
  "corner-down-left",
  "corner-down-right",
  "corner-up-left",
  "corner-up-right",
  "credit-card",
  "credit-card-juicy",
  "crosshair",
  "database",
  "dollar-sign",
  "donut",
  "door-closed",
  "download",
  "drawer-closed-left",
  "drawer-closed-right",
  "drawer-open-left",
  "drawer-open-right",
  "drill",
  "droplet",
  "droplet-filled",
  "ellipsis",
  "external-link",
  "eye",
  "eye-closed",
  "file",
  "file-code",
  "file-question-mark",
  "file-text",
  "filter",
  "flag",
  "flame",
  "folder",
  "folder-kanban",
  "function",
  "gift",
  "git-branch",
  "git-merge",
  "globe",
  "globe-juicy",
  "grid-dots",
  "grip-vertical",
  "group",
  "hammer",
  "hard-drive",
  "hard-hat",
  "hash",
  "heading-1",
  "heading-2",
  "heading-3",
  "heading-4",
  "heart",
  "heart-handshake",
  "heart-pulse",
  "heart-pulse-filled",
  "help-circle",
  "history",
  "home",
  "home-filled",
  "hourglass",
  "image",
  "inbox",
  "indent-decrease",
  "indent-increase",
  "info",
  "italic",
  "keyboard",
  "landmark",
  "layers",
  "layout-dashboard",
  "layout-grid",
  "lightbulb",
  "link",
  "list",
  "list-checks",
  "list-ordered",
  "live-streaming",
  "loader",
  "lock",
  "lock-filled",
  "log-out",
  "mail",
  "mail-check",
  "mail-open",
  "map-pin",
  "map-pin-filled",
  "map-pin-juicy",
  "map-pin-plus",
  "maximize",
  "maximize-2",
  "medal",
  "menu",
  "message",
  "message-dot",
  "message-text",
  "minimize",
  "minus",
  "monitor",
  "moon",
  "more-vertical",
  "mouse-pointer-click",
  "navigation",
  "network",
  "notebook-pen",
  "orbit",
  "orbit-filled",
  "package",
  "package-juicy",
  "paint-roller",
  "palette",
  "panel-right",
  "panel-right-close",
  "paperclip",
  "paw",
  "pen-line",
  "pen-tool",
  "pencil",
  "percent",
  "person",
  "phone",
  "phone-juicy",
  "pickaxe",
  "pie-chart",
  "piggy-bank",
  "pilcrow",
  "pin",
  "pipette",
  "play",
  "play-circle",
  "plug",
  "plus",
  "power",
  "power-off",
  "puzzle",
  "pyramid",
  "quote",
  "radar",
  "redo",
  "reload",
  "repeat",
  "replace",
  "reply",
  "rocket",
  "rotate",
  "rotate-cw",
  "ruler",
  "salestrak",
  "save",
  "save-check",
  "save-off",
  "scroll",
  "search",
  "search-x",
  "send",
  "settings",
  "settings-2",
  "settings-filled",
  "shapes",
  "shapes-filled",
  "share",
  "shield",
  "shield-filled",
  "shield-minus",
  "shovel",
  "shuffle",
  "skip-back",
  "skip-forward",
  "sliders-horizontal",
  "sliders-horizontal-filled",
  "smartphone",
  "smile",
  "smile-plus",
  "sparkles",
  "speech",
  "split",
  "square",
  "square-arrow-down",
  "square-arrow-enter-right",
  "square-arrow-enter-right-juicy",
  "square-check",
  "square-code",
  "square-pen",
  "square-user-round",
  "star",
  "star-filled",
  "strikethrough",
  "sun",
  "sun-filled",
  "sun-moon",
  "swatch-book",
  "swatch-book-filled",
  "table",
  "table-properties",
  "tablet",
  "tag",
  "tag-filled",
  "tag-juicy",
  "target",
  "text",
  "text-cursor-input",
  "text-cursor-input-filled",
  "text-select",
  "thumbs-down",
  "thumbs-up",
  "timer",
  "trash",
  "trash-filled",
  "tree-pine",
  "trending-up",
  "trophy",
  "truck",
  "type",
  "underline",
  "undo",
  "unlink",
  "unplug",
  "upload",
  "user",
  "user-check",
  "user-filled",
  "user-lock",
  "user-lock-filled",
  "user-notebook",
  "user-notebook-filled",
  "user-notebook-juicy",
  "user-plus",
  "users",
  "users-filled",
  "users-juicy",
  "view-board",
  "view-dashboard",
  "view-list",
  "voicemail",
  "volume",
  "wand-sparkles",
  "webhook",
  "wifi",
  "wifi-off",
  "workflow",
  "workflow-filled",
  "workflow-juicy",
  "wrench",
  "x",
  "x-circle",
  "zap",
  "zap-filled",
  "zap-off",
  "zoom-in",
  "zoom-out"
] as const
export type GeneratedIconName = typeof iconNames[number]
